var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.sumModalProps,
        title: _vm.title,
      },
    },
    [
      _c("template", { slot: "default" }, [
        _vm.radioList.length
          ? _c(
              "div",
              { staticClass: "radio-list" },
              _vm._l(_vm.radioList, function (radio, index) {
                return _c(
                  "list-item",
                  {
                    key: index,
                    staticClass: "radio-item",
                    attrs: {
                      title: _vm.getTitleText(radio),
                      footer: _vm.getFooterText(radio),
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.selectRadio(radio)
                      },
                    },
                  },
                  [
                    _vm.isActive(radio)
                      ? _c(
                          "div",
                          {
                            staticClass: "selected",
                            attrs: { slot: "after" },
                            slot: "after",
                          },
                          [_c("i", { staticClass: "far fa-check" })]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              1
            )
          : _c("span", [_vm._v(_vm._s(_vm.emptyText))]),
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          { staticClass: "btn btn-default", on: { click: _vm.modalClose } },
          [_vm._v(_vm._s(_vm.$t("cancel")))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }